import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { Store } from '@ngrx/store';
import * as reducers from '../../reducers';
import * as productActions from '../product.actions';
import { Facets } from '../../shared/interface/facets';
import { ProductDetails } from '../../shared/interface/product-details';
import { Subject } from 'rxjs';
import { ProductService } from '../product.service';


@Component({
  selector: 'tab-section',
  templateUrl: './tab-section.component.html',
  styleUrls: ['./tab-section.component.css']
})
export class TabSectionComponent implements OnInit {
  @Input() productFilter: Facets[];
  @Input() locale: string;
  @Output() clearFilter = new EventEmitter();
  activeTab;

  productDetails: ProductDetails[] = [];

  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(private elementRef: ElementRef, private store: Store<reducers.State>, private productService: ProductService) { }

  ngOnInit() {
    //     let _hash = window.location.href;
    //         _hash = _hash.split('tab=')[1];
    //    if(_hash){
    //     _hash = _hash.substr(0,7);
    //     $('ul.page_tabs li').removeClass('active_pane');
    //     $('.page_tabs_pane').removeClass('active_pane');
    //     $("#" + _hash).addClass('active_pane');
    //     $("div #" + _hash).addClass('active_pane');
    //    }
    // const elem = document.getElementById('id_Maestro');

    const tabArray: Array<{ id: string, tabName: string }> = [
      { id: 'dabbler', tabName: 'Creative Dabbler' },
      { id: '%22CREATIVE_MAESTRO%22', tabName: 'Creative Maestro' },
      { id: '%22CREATIVE_POWERHOUSE%22', tabName: 'Creative Powerhouse' },
      { id: '%22ENTERPRISE_PRO%22', tabName: 'Enterprise Pro' },
    ];
    let _hash = window.location.href;
    if (_hash.split('personaType=')[1]) {
      _hash = _hash.split('personaType=')[1];
      _hash = _hash.split('&')[0];
      if (_hash) {
        tabArray.forEach(function (value) {
          if (value.id == _hash) {
            _hash = value.tabName;
          }
        });
        this.activeTab = _hash;
      }
    } else { this.activeTab = 'Creative Dabbler'; }

  }

  clearLeftFilter() {
    this.clearFilter.emit();
  }
  dispatchMaePersona() {
    const elem = document.getElementById('id_Maestro');
    // elem.dispatchEvent(new Event('click'));
    setTimeout(function () {
      elem.dispatchEvent(new Event('click'));
    }, 900);
  }
  dispatchPowPersona() {
    const elem = document.getElementById('id_Powerhouse');
    // elem.dispatchEvent(new Event('click'));
    setTimeout(function () {
      elem.dispatchEvent(new Event('click'));
    }, 900);
  }
  dispatchEntProPersona() {
    const elem = document.getElementById('id_EntPro');
    // elem.dispatchEvent(new Event('click'));
    setTimeout(function () {
      elem.dispatchEvent(new Event('click'));
    }, 900);
  }

  switchTab(activeTab) {
    this.activeTab = activeTab;

    if (activeTab && this.activeTab != 'Creative Dabbler') { this.changed('', activeTab); } else { this.clearLeftFilter(); }

    if (activeTab == 'Creative Maestro') {
      // this.getFilteredAllPersonaType();
      this.dispatchMaePersona();
      return;
    }
    if (activeTab == 'Creative Powerhouse') {
      this.dispatchPowPersona();
      // this.getFilteredAllPersonaType();
      return;
    }
    if (activeTab == 'Enterprise Pro') {
      this.dispatchEntProPersona();
      // this.getFilteredAllPersonaType();
      return;
    }

  }


  changed(val, selection) {

    let payload;

    let filter_selection: any,
      filterItem = this.productFilter;
    filterItem.forEach(function (value) {
      if (value.displayName == 'gpu') {
        filter_selection = value;
      }
    });

    if (selection == 'Creative Dabbler') {

      payload = {
        displayName: filter_selection.displayName,
        filterField: filter_selection.filterField,
        // displayName: this.productFilter[2].displayName,
        // filterField: this.productFilter[2].filterField,
        locale: this.locale,

        // limit: "90",
        values: {
          dispValue: '',
          // dispValue: personaGpuCValues,
          // dispValue: "GTX 1650 Ti,GTX 1660 Ti,GTX 1660 SUPER,GTX 1660,GTX 1650 SUPER,GTX 1650",
          dispValueDesription: null,
          units: 1,
          checked: false,
          imageURL: null
        },
        trueValue: true,
        fieldType: "checkbox",
        filterValues: '',
        // filterValues: filter_selection.filterValues,
        // filterValues: this.productFilter[2].filterValues,
        tab: "nv_tb_1",
        // persona: 'dabbler',
        personaType: '"CREATIVE_DABBLER_CONSUMER"'
      }

    }

    if (selection == 'CreativeDabbler-enterprise') {

      payload = {
        displayName: filter_selection.displayName,
        filterField: filter_selection.filterField,
        // displayName: this.productFilter[2].displayName,
        // filterField: this.productFilter[2].filterField,
        // limit: "90",
        values: {
          dispValue: '',
          // dispValue: personaGpuEValues,
          // dispValue: "Quadro T1000,Quadro T2000",
          dispValueDesription: null,
          units: 1,
          checked: false,
          imageURL: null
        },
        trueValue: true,
        fieldType: "checkbox",
        filterValues: '',
        // filterValues: filter_selection.filterValues,
        // filterValues: this.productFilter[2].filterValues,
        tab: "nv_tb_1",
        // persona: 'dabbler',
        personaType: '"CREATIVE_DABBLER_ENTERPRISE"'
      }

      // this.clearFilteredDablerEntPersonaType();
    }

    if (selection == 'Creative Maestro') {
      // let payload;
      if (this.locale == "en-us") {

        payload = {
          // gpu: personaGpuValues,
          // gpu: "RTX 2070 SUPER,RTX 2070,RTX 2060 SUPER,RTX 2060,Quadro RTX 4000,Quadro RTX 3000",
          limit: "9",
          locale: this.locale,
          // manufacturer: personaManuValues,
          // manufacturer: "ACER,ASUS,BOXX,GIGABYTE,MAINGEAR,MSI,NZXT,ORIGIN PC,PUGET,RAZER",
          page: 1,
          tab: "nv_tb_2",
          // persona: 'maestro',
          personaType: '"CREATIVE_MAESTRO"'
        }

      } else if (this.locale == "en-gb") {

        payload = {
          // gpu: personaGpuValues,
          // gpu: "RTX 2070 SUPER,RTX 2070,RTX 2060 SUPER,RTX 2060,Quadro RTX 4000,Quadro RTX 3000",
          limit: "9",
          locale: this.locale,
          // manufacturer: personaManuValues,
          // manufacturer: "ACER,ASUS,BOXX,GIGABYTE,MAINGEAR,MSI,NZXT,ORIGIN PC,PUGET,RAZER,PC SPECIALIST",
          page: 1,
          tab: "nv_tb_2",
          // persona: 'maestro',
          personaType: '"CREATIVE_MAESTRO"'
        }

      } else {
        payload = {
          limit: "9",
          locale: this.locale,
          page: 1,
          tab: "nv_tb_2",
          personaType: '"CREATIVE_MAESTRO"'
        }
      }

      this.store.dispatch(new productActions.UpdateProductParamsOnload(payload));
      return;
    }

    if (selection == 'Creative Powerhouse') {
      let payload;
      if (this.locale == "en-us") {

        payload = {
          // gpu: personaGpuValues,
          // gpu: "TITAN RTX,RTX 2080 Ti,RTX 2080 SUPER,RTX 2080,Quadro RTX 8000,Quadro RTX 6000,Quadro RTX 5000,RTX 3080",
          limit: "9",
          locale: this.locale,
          // manufacturer: personaManuValues,
          // manufacturer: "ACER,ASUS,BOXX,GIGABYTE,MAINGEAR,MSI,NZXT,ORIGIN PC,PUGET,RAZER",
          page: 1,
          tab: "nv_tb_3",
          // persona: 'powerhouse',
          personaType: '"CREATIVE_POWERHOUSE"'
        }

      } else if (this.locale == "en-gb") {

        payload = {
          // gpu: personaGpuValues,
          // gpu: "TITAN RTX,RTX 2080 Ti,RTX 2080 SUPER,RTX 2080,Quadro RTX 8000,Quadro RTX 6000,Quadro RTX 5000",
          limit: "9",
          locale: this.locale,
          // manufacturer: personaManuValues,
          // manufacturer: "ACER,ASUS,BOXX,GIGABYTE,MAINGEAR,MSI,NZXT,ORIGIN PC,PUGET,RAZER,PC SPECIALIST",
          page: 1,
          tab: "nv_tb_3",
          // persona: 'powerhouse',
          personaType: '"CREATIVE_POWERHOUSE"'
        }

      } else {
        payload = {
          limit: "9",
          locale: this.locale,
          page: 1,
          tab: "nv_tb_3",
          personaType: '"CREATIVE_POWERHOUSE"'
        }
      }
      this.store.dispatch(new productActions.UpdateProductParamsOnload(payload));
      return;
    }

    if (selection == 'Enterprise Pro') {
      let payload;

      payload = {
        // gpu: personaGpuValues,
        // gpu: "quadro,Quadro RTX 5000,Quadro RTX 4000,Quadro RTX 3000,Quadro RTX 6000,Quadro RTX 8000",
        limit: "9",
        locale: this.locale,
        // manufacturer: personaManuValues,
        // manufacturer: "HP,DELL,LENOVO",
        page: 1,
        tab: "nv_tb_4",
        // persona: 'enterprisepro',
        personaType: '"ENTERPRISE_PRO"'
      }
      this.store.dispatch(new productActions.UpdateProductParamsOnload(payload));
      return;
    }

    // this.clearLeftFilter();

    this.store.dispatch(new productActions.UpdateProductParams(payload));
  }
}
